<template>
  <div>
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
    <v-container class="verification-link">
      <v-layout row>
        <v-flex xs6 offset-xs3 class="">
          <v-card class="container border-all-1 corner-all-10 box_s">
            <h3>
              Set Password
            </h3>
            <v-card-text class="pl0">
              <v-text-field
                ref="password"
                label="Enter Password"
                v-model="password"
                type="password"
                data-vv-name="Password"
                data-vv-validate-on="input|update|change|blur"
                v-validate="{required: true, regex: $store.state.passwordRegex}"
                :error-messages="errors.collect('Password')">
              </v-text-field>

              <v-text-field
                label="Confirm Password"
                v-model="confirmPassword"
                type="password"
                data-vv-name=" password"
                data-vv-validate-on="input|update|change|blur"
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect(' password')">
              </v-text-field>
              <p class="mt-2">
                Password MUST contain an uppercase alphabet, a lowercase alphabet, a number and a symbol (!,@,#,$,%,&,*,-), and be AT LEAST 8 characters in length.
              </p>
              <div class="disFlex">
                <v-checkbox
                  class="mt-0 pt-0 flex-grow-0"
                  v-model="acceptPolicy"
                  type="checkbox"
                  value="true"
                  v-validate="'required'"
                  label=''
                  data-vv-name='Master Services Agreement'
                  required
                ></v-checkbox>
                  <!-- :error-messages="errors.collect('Master Services Agreement')"> -->

                <!-- label="I agree with the Master Services Agreement." -->
                <span class="checkbox_align">I have read and agree to the
                  <a v-if="showSLA" class='linkColor' @click="routeToStaticPage(setSLA)">Service Level Agreement</a>
                  <span v-if="showSLA && showEULA && showPrivacyPolicy"> , </span>
                  <a v-if="showEULA" class='linkColor' @click="routeToStaticPage(setEULA)">Master Services Agreement</a>
                  <span v-if="(showEULA && showSLA) || (showEULA && showPrivacyPolicy) || (showSLA && showPrivacyPolicy)"> and </span>
                  <a v-if="showPrivacyPolicy" class='linkColor' @click="routeToStaticPage(setPrivacyPolicy)">Privacy Policy</a>.
                </span>
              </div>
            </v-card-text>
            <v-card-actions class="pl0">
              <v-btn color="primary" :disabled='!confirmDialog || errors.any()' @click="setPassword">Submit</v-btn>
              <!-- <v-btn @click="password = '', confirmPassword = ''">Clear</v-btn> -->
            </v-card-actions>
            <!-- <v-btn block @click="resendVerificationLink">Resend verification link</v-btn> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SetPassword',
  data: () => ({
    password: '',
    confirmPassword: '',
    data: {},
    color: '',
    alert: false,
    message: '',
    privacyData: '',
    showPrivacyPolicy: false,
    setPrivacyPolicy: '',
    showEULA: true,
    showSLA: true,
    eulaData: '',
    slaDate: '',
    setEULA: '',
    setSLA: '',
    acceptPolicy: false

  }),
  mounted () {
    let userDetails = this.$route.params
    if (!(Object.keys(userDetails).length > 0)) {
      this.$router.push('/signup')
    } else {
      this.data = userDetails
    }
  },
  computed: {
    confirmDialog () {
      let isValid = true
      isValid = (this.password && (this.password === this.confirmPassword) && this.acceptPolicy)
      return isValid
    }
  },
  methods: {
    setPassword () {
      this.$set(this.data, 'password', this.password)
      this.$set(this.data, 'confirmPassword', this.confirmPassword)
      this.$store.dispatch('ACTION_COMPLETE_ACCOUNT', { ...this.data }).then(res => {
        if (!res.success) {
          this.color = 'error'
          this.message = res.error.message || 'Something went wrong.'
          this.alert = true
          setTimeout(() => {
            this.$router.push('/signup')
          }, 3000)
        } else {
          this.$store.state.forEmailVerification = false
          this.$store.state.forAdminApproval = false
          this.$router.push('/success')
        }
      })
    },
    routeToStaticPage (page) {
      if (page === 'sla') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.slaData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Service Level Agreement')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
      if (page === 'eula') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.eulaData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Master Services Agreement')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
      if (page === 'privacyPolicy') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.privacyData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Privacy Policy')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
    }
  },
  created() {
    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'sla' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showSLA = true
        this.slaData = atob(res)
        this.setSLA = 'sla'
      } else {
        this.showSLA = false
      }
    })

    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'eula' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showEULA = true
        this.eulaData = atob(res)
        this.setEULA = 'eula'
      } else {
        this.showEULA = false
      }
    })

    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'privacyPolicy' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showPrivacyPolicy = true
        this.privacyData = atob(res)
        this.setPrivacyPolicy = 'privacyPolicy'
      } else {
        this.showPrivacyPolicy = false
      }
    })
  }
}
</script>

<style>

</style>
